var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-top": "10px" } },
    _vm._l(_vm._value, function (org, index) {
      return _c(
        "el-tag",
        {
          key: index + "_org",
          staticClass: "org-item",
          attrs: {
            type: org.type === "dept" ? "" : "info",
            closable: _vm.closable,
            size: "mini",
          },
          on: {
            close: function ($event) {
              return _vm.removeOrgItem(index)
            },
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(org.name || org.username || org.deptName || org.postName) +
              _vm._s(org.mobile ? "(" + org.mobile + ")" : "") +
              "\n    "
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }